/**
 * Determines the background color for a meeting row based on its time status
 * @param {string} meetingTimeStatus - The status of the meeting ('live', 'done', or other)
 * @returns {string} The background color class
 */
export function getMeetingBackgroundColor(meetingTimeStatus) {
  const isLive = meetingTimeStatus === 'live';
  const isDone = meetingTimeStatus === 'done';

  if (isLive) {
    return 'surface.containerLowest';
  } else if (isDone) {
    return 'surface.containerLow';
  } else {
    return 'surface.containerHigh';
  }
}

/**
 * Determines the action button configuration for a meeting row
 * @param {Object} params - Parameters object
 * @param {Object} params.stateForMeetingUI - Meeting UI state object with text property
 * @param {string} params.meetingTimeStatus - The status of the meeting ('live', 'done', or other)
 * @param {Function} params.startMeetingAndRecording - Function to start meeting and recording
 * @param {boolean} params.showAddForaButton - Whether to show add fora button
 * @param {boolean} params.showAddForaBackButton - Whether to show add fora back button
 * @param {Object} params.addForaModalDisclosure - Modal disclosure object with onOpen method
 * @param {boolean} params.wasSummarized - Whether the meeting was summarized
 * @param {boolean} params.hasTranscripts - Whether the meeting has transcripts
 * @returns {Object|null} Action button configuration object or null
 */
export function getMeetingActionButton({
  stateForMeetingUI,
  meetingTimeStatus,
  startMeetingAndRecording,
  showAddForaButton,
  showAddForaBackButton,
  addForaModalDisclosure,
  wasSummarized,
  hasTranscripts
}) {
  const isLive = meetingTimeStatus === 'live';
  const isDone = meetingTimeStatus === 'done';

  if (stateForMeetingUI.text === 'Fora is not Scheduled' && isLive) {
    return {
      text: 'Start recording',
      color: 'live.primary',
      onClick: startMeetingAndRecording
    };
  } else if (
    stateForMeetingUI.text === 'Fora is not Scheduled' &&
    (showAddForaButton || showAddForaBackButton)
  ) {
    return {
      text: 'Enable recording',
      color: 'surface.onSurfaceVariant',
      onClick: addForaModalDisclosure.onOpen
    };
  } else if (isDone && !wasSummarized && !hasTranscripts) {
    return {
      text: 'Not recorded',
      color: 'surface.outline',
      propagate: true
    };
  } else if (stateForMeetingUI.text === 'Summarizing') {
    return {
      text: 'Summarizing',
      color: 'surface.onSurfaceVariant',
      propagate: true
    };
  } else if (wasSummarized) {
    return {
      text: 'View summary',
      color: 'surface.onSurfaceVariant',
      propagate: true
    };
  } else {
    return null;
  }
}
